export default __webpack_public_path__ + "static/media/kiraly_alacart.9fc44e9b.png";